import cn from "classnames";

import styles from "./count-display.module.scss";

interface CountDisplayProps {
  current: number;
  target: number;
  onIncrement: () => void;
  "aria-label"?: string;
  "data-testid"?: string;
}

export function CountDisplay({
  current,
  target,
  onIncrement,
  "aria-label": ariaLabel,
  "data-testid": testId,
}: CountDisplayProps) {
  const isComplete = current >= target;

  return (
    <button
      type="button"
      className={cn(styles.display, isComplete && styles.complete)}
      onClick={(e) => {
        e.stopPropagation();
        onIncrement();
      }}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      <span className={styles.current}>{current}</span>
      <span className={styles.separator}>/</span>
      <span className={styles.target}>{target}</span>
    </button>
  );
}
